import InfoIcon from '@mui/icons-material/Info';
import {
  Avatar,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import React from 'react';

import { getInitials } from '~/services/Employee';
import { People } from '~/services/Http';

import { useSxStyles } from './useStyles';

export interface Props {
  teamMembers: People.TeamMemberDto[];
  activeMemberId?: number;
  handleActiveMemberChange: (employeeId: number) => void;
  handleShowMemberDetails: (employeeId: number) => void;
}

export const EmployeeList: React.FC<Props> = ({
  teamMembers,
  activeMemberId,
  handleActiveMemberChange,
  handleShowMemberDetails,
}) => {
  const sxStyles = useSxStyles();

  const listItems = teamMembers.map((employee: People.TeamMemberDto) => {
    const fullName = `${employee.firstName} ${employee.lastName}`;

    return (
      <ListItem
        key={employee.employeeId}
        secondaryAction={
          <IconButton
            onClick={() => handleShowMemberDetails(employee.employeeId)}
            data-cy="info-icon"
          >
            <InfoIcon color="primary" />
          </IconButton>
        }
        disableGutters={true}
        sx={{ padding: 0 }}
      >
        <ListItemButton
          onClick={() => handleActiveMemberChange(employee.employeeId)}
          selected={employee.employeeId === activeMemberId}
          sx={{ padding: 0 }}
        >
          <ListItemAvatar>
            <Avatar
              src={employee.profilePic}
              alt={getInitials(employee.firstName, employee.lastName)}
              title={fullName}
              className={'avatar'}
              data-cy="profile-pic"
              sx={sxStyles.avatar}
            />
          </ListItemAvatar>
          <ListItemText
            primary={fullName}
            secondary={employee.positionName.value}
            slotProps={{
              primary: {
                sx: sxStyles.primaryContent,
              },
              secondary: {
                sx: sxStyles.secondaryContent,
              },
            }}
          />
        </ListItemButton>
      </ListItem>
    );
  });

  return (
    <Box data-cy="list" sx={sxStyles.list}>
      <List sx={sxStyles.mainList}>{listItems}</List>
    </Box>
  );
};
